import { __extends } from "tslib";
import EventEmitter from "eventemitter3";
var ModalEmitter = /** @class */ (function (_super) {
    __extends(ModalEmitter, _super);
    function ModalEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModalEmitter;
}(EventEmitter));
export var modalEventEmitter = new ModalEmitter();
//# sourceMappingURL=event.js.map